export const MFloatButtonColors = {
  containerBg: '#000000',
  containerBgDisabled: '#E5E5E8',
  arrow: '#FFFFFF',
};
